export default __webpack_public_path__ + "static/media/twentyeightdays2.0bc98cdc.jpg";